import { z } from 'zod';
import { ArtifactSchema } from '../../entities/artifact/artifact.schema';
/**
 * List Artifacts Request Schema
 * GET /api/v2/artifacts
 */ export const ListArtifactsRequestSchema = z.object({});
/**
 * List Artifacts Response Schema
 * GET /api/v2/artifacts
 */ export const ListArtifactsResponseSchema = z.object({
    data: z.array(ArtifactSchema)
});

//# sourceMappingURL=list-artifacts.schema.js.map